// thunk.ts
//
// All the thunks for the users interactions part of the admin functionality

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getEndpoint, postEndpoint } from "../../api";

/**
 * Fetches all users from the server.
 *
 * `getEndpoint` swallows request errors and resolves with the raw error
 * object instead of rejecting (see `logic/api.ts`), so a failed/denied
 * request would otherwise still hit `.fulfilled` with a non-array payload.
 * Guard against that here so the slice doesn't crash trying to `.map()` it.
 */
export const getAllUsers = createAsyncThunk(
  "admin/users/all",
  async (_: void, { rejectWithValue }) => {
    const response = await getEndpoint(`api/user/all`, "");
    if (!Array.isArray(response)) {
      return rejectWithValue(response);
    }
    return response;
  },
);

export const extendUserPremium = createAsyncThunk(
  "admin/user/premium",
  async (body: { targetUserId: string }) =>
    postEndpoint(`api/user/premium`, "", body),
);
